import * as Yup from 'yup';
import { toMexicoCityInstant } from 'src/utils/momentLocalTimezone';

export default currentDueDate => {
  const today = toMexicoCityInstant().startOf('day');
  const dueDateMoment = currentDueDate
    ? toMexicoCityInstant(currentDueDate)
    : today;

  // Get the first day of the due date's month
  const firstDayOfMonth = dueDateMoment.startOf('month');

  // If due date's month is current month, use today as min date
  // Otherwise use first day of the due date's month
  const minDateValue = dueDateMoment.isSame(today, 'month')
    ? today
    : firstDayOfMonth;

  return Yup.object().shape({
    dueDate: Yup.date()
      .required('CLIENTS_VIEW.CLIENT_DETAIL.VALIDATION.REQUIRED')
      .min(
        minDateValue,
        'CLIENTS_VIEW.CLIENT_DETAIL.VALIDATION.DATE_MUST_BE_VALID'
      )
      .nullable()
  });
};
